type Props = {
    currentTab: number;
};

const steps = [
    { id: 1, label: 'Personal Info', shortLabel: 'Personal' },
    { id: 2, label: 'Password', shortLabel: 'Password' },
    { id: 3, label: 'Finish', shortLabel: 'Finish' },
];

export default function Stepper({ currentTab }: Props) {
    return (
        <div className="mb-5 sm:mb-6">
            <div className="flex items-center justify-between px-0.5 sm:px-1">
                {steps.map((step, index) => {
                    const active = step.id <= currentTab;
                    const current = step.id === currentTab;
                    return (
                        <div key={step.id} className="flex min-w-0 flex-1 items-center last:flex-none">
                            <div className="flex flex-col items-center">
                                <div
                                    className={`flex h-7 w-7 items-center justify-center rounded-full text-[12px] font-semibold transition sm:h-8 sm:w-8 sm:text-[13px] ${
                                        active
                                            ? 'bg-ryd-primary text-white shadow-sm'
                                            : 'bg-[#EDE7F0] text-[#94a3b8]'
                                    } ${current ? 'ring-4 ring-ryd-primary/15' : ''}`}
                                >
                                    {step.id}
                                </div>
                                <p
                                    className={`mt-1.5 max-w-[4.5rem] text-center text-[10px] font-medium leading-tight sm:mt-2 sm:max-w-none sm:whitespace-nowrap sm:text-[11px] ${
                                        active ? 'text-ryd-primary' : 'text-[#94a3b8]'
                                    }`}
                                >
                                    <span className="sm:hidden">{step.shortLabel}</span>
                                    <span className="hidden sm:inline">{step.label}</span>
                                </p>
                            </div>
                            {index < steps.length - 1 && (
                                <div
                                    className={`mx-1.5 mb-5 h-[2px] min-w-[12px] flex-1 rounded-full sm:mx-2 ${
                                        step.id < currentTab ? 'bg-ryd-primary' : 'bg-[#EDE7F0]'
                                    }`}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
